'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const SessionChart = dynamic(() => import('./charts/SessionChart'), {
  ssr: false,
  loading: () => <div className="h-[220px] animate-pulse bg-muted rounded-xl" />,
});

export default function SessionTimelineChart() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-sm font-semibold text-foreground">Session Activity — Last 7 Days</h2>
          <p className="text-xs text-muted-foreground">Minutes per day by content type</p>
        </div>
      </div>
      <SessionChart />
      <div className="flex items-center gap-4 mt-3">
        {[
          { id: 'leg-wildlife', color: 'bg-kid-dolphin', label: 'Wildlife' },
          { id: 'leg-environment', color: 'bg-positive', label: 'Environment' },
          { id: 'leg-guardian', color: 'bg-warning', label: 'Guardian Mode' },
          { id: 'leg-learning', color: 'bg-accent', label: 'Learning Cards' },
        ]?.map((l) => (
          <div key={l?.id} className="flex items-center gap-1.5">
            <span className={`w-2 h-2 rounded-full ${l?.color}`} />
            <span className="text-[10px] text-muted-foreground">{l?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}